import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { AbTestGroupUsersQueryInput } from '@/models/abTest';

export const fetchAbTestGroupUsers = async ({
  abTestGroupIds,
  userId,
  associatedObjectType,
  associatedObjectId,
  isActive,
  pagination,
}: AbTestGroupUsersQueryInput) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      abTestGroupIds,
      userId,
      associatedObjectType,
      associatedObjectId,
      isActive,
      pagination,
    },
    query: graphql(`
      query AbTestGroupUsers(
        $abTestGroupIds: [Float!]!
        $userId: String
        $associatedObjectType: AssocObjType
        $associatedObjectId: String
        $isActive: Boolean
        $pagination: PaginationInputType
      ) {
        abTestGroupUsers(
          abTestGroupIds: $abTestGroupIds
          userId: $userId
          associatedObjectType: $associatedObjectType
          associatedObjectId: $associatedObjectId
          isActive: $isActive
          pagination: $pagination
        ) {
          count
          rows {
            id
            userId
            abTestGroupId
            associatedObjectType
            associatedObjectId
            isActive
            abTestId
            createdAt
            updatedAt
            abTestGroup {
              groupLabel
              groupType
            }
          }
        }
      }
    `),
  });

  return response.data.abTestGroupUsers;
};
